import { c as _c } from "react/compiler-runtime";
import type { Icon } from '@onefootprint/icons';
import { IcoBook16, IcoBuilding16, IcoChart16, IcoCode216, IcoConstruct16, IcoFileSearch16, IcoRobot16, IcoSettings16, IcoSparkles16, IcoStore16, IcoUsers16, IcoWarning16, IcoWriting16 } from '@onefootprint/icons';
import { useTranslation } from 'react-i18next';
import { AUDITOR_ALLOWED_ROUTES } from '@/config/constants';
import usePermissions from '@/hooks/use-permissions';
import type { TenantFeatureGate } from '@/types/tenant';
export type RouteItem = {
  href: string;
  Icon: Icon;
  text: string;
  badgeCount?: number;
  employeesOnly: boolean;
  featureGate?: TenantFeatureGate;
  /** Override the default visibility logic with a custom predicate. */
  isVisible?: boolean;
  /** Extra path prefixes that should also mark this item as active. */
  activeOn?: string[];
};
type Route = {
  items: RouteItem[];
};
type useRoutesProps = {
  riskOpsRequests?: number;
  isRiskOpsTeamMember?: boolean;
};
const useRoutes = t0 => {
  const $ = _c(8);
  const {
    riskOpsRequests: t1,
    isRiskOpsTeamMember: t2
  } = t0;
  const riskOpsRequests = t1 === undefined ? undefined : t1;
  const isRiskOpsTeamMember = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "components.privateLayout.nav"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const {
    t
  } = useTranslation("common", t3);
  const {
    isAuditor
  } = usePermissions();
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = _temp;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let routes;
  let t5;
  if ($[2] !== isAuditor || $[3] !== isRiskOpsTeamMember || $[4] !== riskOpsRequests || $[5] !== t) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      routes = [{
        items: [{
          href: "/ask-percy",
          Icon: IcoSparkles16,
          text: t(t4),
          employeesOnly: false,
          activeOn: ["/chat"]
        }, {
          href: "/users",
          Icon: IcoUsers16,
          text: t(_temp2),
          employeesOnly: false
        }, {
          href: "/businesses",
          Icon: IcoBuilding16,
          text: t(_temp3),
          employeesOnly: false
        }, {
          href: "/reviews",
          Icon: IcoWarning16,
          text: t(_temp4),
          employeesOnly: false
        }, {
          href: "/playbooks",
          Icon: IcoBook16,
          text: t(_temp5),
          employeesOnly: false
        }, {
          href: "/investigations",
          Icon: IcoFileSearch16,
          text: t(_temp6),
          employeesOnly: false
        }, {
          href: "/agents",
          Icon: IcoRobot16,
          text: t(_temp7),
          employeesOnly: false
        }]
      }, {
        items: [{
          href: "/developers",
          Icon: IcoCode216,
          text: t(_temp8),
          employeesOnly: false
        }, {
          href: "/reporting",
          Icon: IcoChart16,
          text: t(_temp9),
          employeesOnly: false
        }, {
          href: "/settings",
          Icon: IcoSettings16,
          text: t(_temp10),
          employeesOnly: false
        }]
      }, {
        items: [{
          href: "/internal/tenants",
          Icon: IcoStore16,
          text: t(_temp11),
          employeesOnly: true
        }, {
          href: "/internal/toolbox",
          Icon: IcoConstruct16,
          text: t(_temp12),
          employeesOnly: true
        }, ...(isRiskOpsTeamMember ? [{
          href: "/internal/risk-ops",
          Icon: IcoWriting16,
          text: t(_temp13),
          badgeCount: riskOpsRequests,
          employeesOnly: true
        }] : [])]
      }];
      if (isAuditor) {
        t5 = routes.map(_temp15);
        break bb0;
      }
    }
    $[2] = isAuditor;
    $[3] = isRiskOpsTeamMember;
    $[4] = riskOpsRequests;
    $[5] = t;
    $[6] = routes;
    $[7] = t5;
  } else {
    routes = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  return routes;
};
export default useRoutes;
function _temp($) {
  return $.askPercy;
}
function _temp2($_0) {
  return $_0.users;
}
function _temp3($_1) {
  return $_1.businesses;
}
function _temp4($_2) {
  return $_2.reviews;
}
function _temp5($_3) {
  return $_3.playbooks;
}
function _temp6($_4) {
  return $_4.investigations;
}
function _temp7($_5) {
  return $_5.agents;
}
function _temp8($_6) {
  return $_6.developers;
}
function _temp9($_7) {
  return $_7.reporting;
}
function _temp10($_8) {
  return $_8.settings;
}
function _temp11($_9) {
  return $_9.tenants;
}
function _temp12($_10) {
  return $_10.toolbox;
}
function _temp13($_11) {
  return $_11.editGrantRequests;
}
function _temp14(item) {
  return {
    ...item,
    isVisible: item.href === "/settings" || AUDITOR_ALLOWED_ROUTES.includes(item.href)
  };
}
function _temp15(t0) {
  const {
    items
  } = t0;
  return {
    items: items.map(_temp14)
  };
}